import * as React from 'react';
import { CircleContainer, Circle as Circle$1, CircleBadge, CircleBadgeText } from './styles.js';

const Circle = ({ icon , borderColor , color , hasBadge , badgeColor , badgeBorderColor , badgeIcon , badgeText , badgeTextColor , isTransparent , testId ="default" , variant  })=>/*#__PURE__*/ React.createElement(CircleContainer, {
        "data-testid": `${testId}-circle`,
        isTransparent: isTransparent
    }, /*#__PURE__*/ React.createElement(Circle$1, {
        "data-testid": `${testId}-circle-content`,
        borderColor: borderColor,
        backgroundColor: color,
        variant: variant
    }, icon), hasBadge && /*#__PURE__*/ React.createElement(CircleBadge, {
        "data-testid": `${testId}-circle-badge`,
        borderColor: badgeBorderColor,
        backgroundColor: badgeColor
    }, badgeIcon && badgeIcon, badgeText && /*#__PURE__*/ React.createElement(CircleBadgeText, {
        "data-testid": `${testId}-circle-badge-text`,
        color: badgeTextColor
    }, badgeText)));

export { Circle };
